const categoryIcons = {
  uv: (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <rect x="3.5" y="6" width="17" height="12" rx="2" stroke="currentColor" strokeWidth="1.7" />
      <path d="M8 15h8" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
      <path d="M12 6V4" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
      <path d="M9 4h6" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
    </svg>
  ),
  cylinder: (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <ellipse cx="12" cy="6.5" rx="5.5" ry="2.2" stroke="currentColor" strokeWidth="1.7" />
      <path
        d="M6.5 6.5v11c0 1.35 2.46 2.5 5.5 2.5s5.5-1.15 5.5-2.5v-11"
        stroke="currentColor"
        strokeWidth="1.7"
      />
      <path d="M6.5 12c0 1.35 2.46 2.5 5.5 2.5s5.5-1.15 5.5-2.5" stroke="currentColor" strokeWidth="1.7" />
    </svg>
  ),
  crystal: (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M12 4.5 17.5 12 12 19.5 6.5 12 12 4.5Z"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinejoin="round"
      />
      <path d="M6.5 12h11" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
      <path d="M12 4.5v15" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
    </svg>
  ),
  dtf: (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <rect x="3.5" y="8" width="17" height="8" rx="1.5" stroke="currentColor" strokeWidth="1.7" />
      <circle cx="8" cy="12" r="2" stroke="currentColor" strokeWidth="1.7" />
      <path d="M13 10.5v3" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
      <path d="M16 10.5v3" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
    </svg>
  ),
  dtg: (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M8.5 5.5h7l1.2 2.8H7.3L8.5 5.5Z"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinejoin="round"
      />
      <path
        d="M6.5 8.3h11v11.2H6.5V8.3Z"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinejoin="round"
      />
      <path d="M10 12.5h4" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
    </svg>
  ),
};

function ProductCategoryIcon({ type }) {
  return categoryIcons[type] || categoryIcons.uv;
}

export default ProductCategoryIcon;
